import { render, staticRenderFns } from "./LoadJson.vue?vue&type=template&id=f208e734&scoped=true"
import script from "./LoadJson.vue?vue&type=script&lang=js"
export * from "./LoadJson.vue?vue&type=script&lang=js"
import style0 from "./LoadJson.vue?vue&type=style&index=0&id=f208e734&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f208e734",
  null
  
)

export default component.exports